import { render, staticRenderFns } from "./RankingsByMatchday.vue?vue&type=template&id=c6b1e1fe&scoped=true"
import script from "./RankingsByMatchday.vue?vue&type=script&lang=js"
export * from "./RankingsByMatchday.vue?vue&type=script&lang=js"
import style0 from "./RankingsByMatchday.vue?vue&type=style&index=0&id=c6b1e1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b1e1fe",
  null
  
)

export default component.exports